<script lang="ts" setup>
import type { FormInput } from "@/types";

defineProps<{
  blok: FormInput;
  modelValue?: string | number;
  hasError?: boolean;
}>();

defineEmits(["update:modelValue"]);
</script>

<template>
  <textarea
    v-editable="blok"
    class="py-4 px-4 border w-full rounded-2xl md:col-span-2"
    :class="{ 'border-red-600': hasError, 'border-black': !hasError }"
    :value="modelValue"
    rows="4"
    :placeholder="blok.placeholder"
    :required="blok.required"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>
